<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <template >
        <v-toolbar flat>  
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-filter</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-flex lg3>
              <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
            </v-flex>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }" >
                <v-btn outlined v-show=insertact  rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                  Add New Data 
                  <v-icon class="ml-2">mdi-plus</v-icon>
                </v-btn>
              </template> 
              <v-card>
                <v-card-title>
                  <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
                </v-card-title>
                <v-card-text class="overflow-card" style="max-height: 330px; overflow-y: auto;">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-account" 
                          outlined dense 
                          v-model="name_server" 
                          label="Name Server">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-account" 
                          outlined dense 
                          v-model="hostSolr" 
                          label="Host Solr">
                        </v-text-field>
                      </v-col>
                      
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-account" 
                          outlined dense 
                          v-model="host" 
                          label="Endpoint">
                        </v-text-field>
                      </v-col>
                      
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-account" 
                          outlined dense 
                          v-model="host_range" 
                          label="Endpoint Range">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-select dense outlined :items="itemsactivate"  item-text="name_active" item-value="valueactive"  v-model="statusactive"  
                        hint="Activate/Disable" persistent-hint></v-select>
                      </v-col>

                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" width="330px"> 
              <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                <v-avatar class="color-avatar3 my-4" size="62">
                  <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                </v-avatar>
                <div class="text-center text-h6 align-center justify-center font-weight-medium">
                  Confirm Deletion
                </div>
                <v-card-text class="align-center justify-center mt-2">
                  Are you sure you want to permanently delete this item?
                </v-card-text>
                <v-divider class="mt-4" style=""></v-divider>
                <v-card-actions class="align-center justify-center">
                  <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                    OK
                  </v-btn>
                  <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- dialog parm setting  -->
        </v-toolbar>
      </template>
      <v-data-table 
      :headers="headers"
      :items="serverData"
      :search="search"
      sort-by="paramid"
      class="ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >

        <!-- Correct slot usage for item.STATUS -->
        <template v-slot:item.STATUS="{ item }">
          <v-chip :color="getColor(item.STATUS)"  text-color="white" label small pill>
            {{ item.STATUS === 1 ? 'Enabled' : 'Disabled' }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon v-show=updateact  small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon v-show=deleteact  @click="deleteItem(item.SEQ_ID)" small>
            mdi-delete
          </v-icon>
          
        
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
      </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.css';
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",

      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      dialog: false,
      dialogDelete: false,
      showiconclass: false,
      
      dialogparmsetting: false,
      search:'',
      headers: [
        { text: 'Name Server', value: 'NAME_SERVER' },
        { text: 'Solr', value: 'HOST_SOLR' },
        { text: 'Endpoint', value: 'HOST' },
        { text: 'Endpoint Range', value: 'HOST_RANGE' },
        { text: 'Status', value: 'STATUS' },
        { text: 'Actions', value: 'actions', sortable: false },
      ], 
      serverData:[],
      id_server:'',
      name_server:'',
      hostSolr:'',
      host:'',
      host_range:'',
      status:'',
      statusactive: 1,
      itemsactivate: [//choice select
        {valueactive: 1, name_active: "Enabled" },
        {valueactive: 0, name_active: "Disabled" }
      ],
      
      editedIndex: -1,
      inputItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add Server' : 'Update Server'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
      // this.$router.push('/server');
    },
    methods: {
      getColor(status) {
        return status === 0 ? 'red' : 'green';
      },
      initialize () {
        this.tableLoading = true;
        axios.get("server-monitoring",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            const data_dec = decryptionData(response.data.data);
            this.serverData = data_dec.result;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }   
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
          })
          .catch((e) => {
              switch (e.response.status) {
                  case 404:
                        // this.$refs.alert.error_login(404);
                      break;
                  case 403:
                        // this.$refs.alert.error_login(403);
                      break;
                  default:
                      console.log('some other error');  // end up here all the time
                      break;
              }
          this.errors=e.response.data.msg;
        });
        
      },
      deleteItem (item) {
        this.id_server = item
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        axios({
          method: "delete",
          url: "/server/delete",
          data: {
            id: this.id_server
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          this.initialize();
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closeDelete()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.closeDelete()
              } 
        })
        .catch(function (error) {
          console.log(error);
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed';
          this.btnload = false
          this.closeDelete()
        })
      },
      closeDelete () {
        this.id_server = ""
        this.dialogDelete = false
      },
      editItem (item) {
        this.id_server = item.SEQ_ID
        this.name_server= item.NAME_SERVER
        this.hostSolr= item.HOST_SOLR
        this.host= item.HOST
        this.host_range= item.HOST_RANGE
        this.status= item.STATUS
        this.dialog = true
        console.log(item)
        setTimeout(() =>{
              this.loading = false
        },1000)
      },
      save () {
        this.btnload = true
          axios.put("/server-action", 
            {
              seqId:this.id_server,
              nameServer:this.name_server,
              hostSolr:this.hostSolr,
              host:this.host,
              hostRange:this.host_range,
              status:this.statusactive,
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            this.initialize();
              this.$router.push('/server');
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      case 400:
                            this.alertFailed = true;
                            this.alert_err_attention =  e.response.msg;
                            this.btnload = false
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                }
            this.errors=e.response.data.msg;
          });
       
      },
      close () {
        this.id_server = ""
        this.dialog = false
      },
      
    },
  }
</script> 

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>
